module.exports = __webpack_public_path__ + "img/DS3622xs+.fb4c12b8.png";